<template>
	<div>
    <ul>
      <li @click="selectedInfo(item.name)" v-for="item in address">{{item.name}}</li>
    </ul>
	</div>
</template>

<script>
export default {
  props: ['address'],
	data: function() {
		return {

		};
	},  // data
  methods: {
    selectedInfo: function(name) {
      this.$emit("send-select", {
        name: name
      });
    }
  } //methods
} //export
</script>

<style scoped>
  ul {
    list-style: none;
    margin-left: 0;
    padding-left: 0;
  }
  
  li {
    font-size: 1.1em;
    margin-bottom: 5px;
  }
  
  li:hover {
    cursor: pointer;
    color: #d1aa75;   
  }
</style>


// WEBPACK FOOTER //
// src/components/ListOfAddresses.vue